import { RelatorioService } from './servicos/relatorio.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { NgModule } from '@angular/core';
import {InputMaskModule} from 'primeng/inputmask';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxUiLoaderModule, NgxUiLoaderConfig } from  'ngx-ui-loader';
import { DaoService } from './servicos/dao.service';
import { EstadoService } from './servicos/estado.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { LoginComponent } from './componentes/login/login.component';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ProgressBarModule} from 'primeng/progressbar';
import {CheckboxModule} from 'primeng/checkbox';
import { CdkVirtualScrollViewport, ScrollDispatcher, ViewportRuler } from '@angular/cdk/scrolling';
import { Platform } from '@angular/cdk/platform';
import { AutenticacaoService } from './servicos/autenticacao.service';
import {InputTextareaModule} from 'primeng/inputtextarea';
import { ValidadorZapComponent } from './validador-zap/validador-zap.component';
import { AceiteTermosComponent } from './aceite-termos/aceite-termos.component';
import { AnimadoComponent } from './animado/animado.component';
import { ToastCustomComponent } from './componentes/toast-custom/toast-custom.component';
import { ToastCustomService } from './servicos/toast-custom.service';

const ngxUiLoaderConfig: any = {
  "bgsColor": "#F58634",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 15,
  "fgsColor": "#F58634",
  "fgsPosition": "center-center",
  "fgsSize": 110,
  "fgsType": "three-strings",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 0,
  "logoUrl": "",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(3, 7, 18, 0.75)",
  "pbColor": "#F58634",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "CARREGANDO",
  "textColor": "#FFB75E",
  "minTime": 200
};


import { MascaraModule } from './util/mascara.module';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ValidadorZapComponent,
    AceiteTermosComponent,
    AnimadoComponent,
    ToastCustomComponent
  ],
  imports: [
    BrowserModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    FormsModule,
    InputTextareaModule,
    InputMaskModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    ConfirmDialogModule,
    ProgressBarModule,
    MascaraModule,
    CheckboxModule
  ],
  providers: [
    ToastCustomService,
    { provide: MessageService, useExisting: ToastCustomService },
    AutenticacaoService,RelatorioService,ConfirmationService,DaoService,HttpClient,EstadoService, CdkVirtualScrollViewport,
    ScrollDispatcher, Platform, ViewportRuler],
  bootstrap: [AppComponent]
})
export class AppModule { }
